<template>
  <div class="page">
    <h1>Rezepte</h1>
    <div class="hub-grid">
      <router-link
        v-for="Karte in Karten"
        :key="Karte.Pfad"
        :to="Karte.Pfad"
        class="hub-karte"
      >
        <span class="hub-icon" :style="{ background: Tint(Karte.Farbe), color: Karte.Farbe }">
          <font-awesome-icon :icon="Karte.Icon" />
        </span>
        <span class="hub-text">
          <span class="hub-titel">{{ Karte.Titel }}</span>
          <span class="hub-untertitel">{{ Karte.Untertitel }}</span>
        </span>
        <font-awesome-icon icon="fa-solid fa-chevron-right" class="hub-pfeil" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RezepteView',
  data() {
    return {
      Karten: [
        { Pfad: '/rezepte/neu',        Icon: 'fa-solid fa-plus',       Farbe: '#3DA568', Titel: 'Neues Rezept',         Untertitel: 'Rezept mit Zutaten anlegen' },
        { Pfad: '/rezepte/liste',      Icon: 'fa-solid fa-book-open',  Farbe: '#E07B2A', Titel: 'Rezepte Liste',        Untertitel: 'Durchsuchen, bearbeiten & löschen' },
        { Pfad: '/rezepte/eingefroren', Icon: 'fa-solid fa-snowflake', Farbe: '#2E8FC0', Titel: 'Eingefrorene Rezepte', Untertitel: 'Alle eingefrorenen Gerichte auf einen Blick' }
      ]
    }
  },
  methods: {
    Tint(Farbe) {
      return `color-mix(in srgb, ${Farbe} 15%, transparent)`
    }
  }
}
</script>
